import { Alert } from "antd";
import { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { locale, t } from "../MainApp";

type TimeCheckerProps = {
    start: Dayjs;
    end: Dayjs;

    locale: locale;
};

export function TimeChecker(props: TimeCheckerProps) {
    let [timeIsValid, setTimeIsValid] = useState<boolean>(false);

    useEffect( () => {
        if(props.start.unix() >= props.end.unix()) {
            setTimeIsValid(false);
        } else {
            setTimeIsValid(true);
        }
    }, [props.start, props.end]);

    return (
        timeIsValid === false
        ? <Alert type="error" message={t(props.locale, "startTimeGreaterThanEnd")} />
        : <></>        
    );
}